import React from 'react';
import styled from 'styled-components';
import { Grid } from '../../../app/StyleGuide';
import { PrimaryButton } from '../../../components/Buttons';
import trainingService from '../../../services/trainingService';
import windowService from '../../../services/windowService';
import { TrainingPoster } from './TrainingHeader';
import { TrainingAssignmentCard } from './TrainingAssignmentCard';
import { ActivePathwayOverview } from '../models/assignment';
import {
  TrainingName,
  Description,
  Container,
  TrainingPosterContainer,
  Subtitle,
  TitleContainer,
} from './RequireOrgForTrainingViewElements';

const ContinueButton = styled(PrimaryButton)`
  min-width: 200px;
`;

const CardWrapper = styled.div`
  width: 100%;
  margin-bottom: ${Grid._4};
  text-align: left;
`;

type TrainingExistsProps = {
  trainingId: string;
  trainingName: string;
  trainingInstance: ActivePathwayOverview;
  trainingPosterImage?: string;
};

export const TrainingExists = ({ trainingName, trainingPosterImage, trainingInstance }: TrainingExistsProps) => {
  const upNext = trainingInstance.activeCourse?.upNext;

  return (
    <Container>
      {trainingPosterImage ? (
        <TrainingPosterContainer>
          <TrainingPoster src={trainingService.getTrainingImageUrl(trainingPosterImage)} alt={trainingName} />
        </TrainingPosterContainer>
      ) : (
        <TitleContainer>
          <Subtitle>Continue With</Subtitle>
          <TrainingName>{trainingName}</TrainingName>
        </TitleContainer>
      )}

      <Description>Pick up right where you left off. You can also continue from your dashboard anytime.</Description>

      <CardWrapper>
        <TrainingAssignmentCard assignment={trainingInstance} />
      </CardWrapper>

      <ContinueButton
        onClick={() =>
          upNext &&
          windowService.redirectTo(
            '#/training-steps/' + trainingInstance.instanceId + `?stepId=${upNext.instanceId}&isWorkflow=true`
          )
        }
      >
        Continue
      </ContinueButton>
    </Container>
  );
};
